import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "py-12 px-4 text-center text-sm text-red-600"
}
const _hoisted_2 = {
  key: 1,
  class: "min-h-screen bg-background py-12 px-4"
}
const _hoisted_3 = { class: "mx-auto max-w-4xl" }

import { ref, computed, watch, onMounted } from 'vue'
import StepIndicator from '@/components/marketplace/company/registration/StepIndicator.vue'
import GetStartedStep from '@/components/marketplace/company/registration/GetStartedStep.vue'
import CompanyDetailsStep from '@/components/marketplace/company/registration/CompanyDetailsStep.vue'
import CompanyProfileStep from '@/components/marketplace/company/registration/CompanyProfileStep.vue'
import OperationsOverviewStep from '@/components/marketplace/company/registration/OperationsOverviewStep.vue'
import ManagerInformationStep from '@/components/marketplace/company/registration/ManagerInformationStep.vue'

import { useCompanyRegistrationStore } from '@/stores/companyRegistrationStore'
import { useCompanyIndustryProfileStore } from '@/stores/companyIndustryProfileStore'


export default /*@__PURE__*/_defineComponent({
  __name: 'Register',
  setup(__props) {

const store = useCompanyRegistrationStore()
const industryProfileStore = useCompanyIndustryProfileStore()

const stepLabels = [
  'Get Started',
  'Company Details',
  'Company Profile',
  'Operations Overview',
  'Manager Info',
]

watch(() => store.currentStep, () => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
})

onMounted( async() => {
  await store.initDraft()
  store.fetchIndustries()
  store.fetchCompanyIndustryOptions()
  industryProfileStore.fetchProfiles()
})

return (_ctx: any,_cache: any) => {
  return (_unref(industryProfileStore).error)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(industryProfileStore).error), 1))
    : (_unref(store).isLoaded && _unref(industryProfileStore).isLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "mb-8 text-center" }, [
              _createElementVNode("h1", { class: "text-3xl font-semibold mb-2" }, "Company Registration"),
              _createElementVNode("p", { class: "text-muted-foreground" }, " Complete your company profile to get started with Screened ")
            ], -1)),
            _createVNode(StepIndicator, {
              "current-step": _unref(store).currentStep,
              "total-steps": _unref(store).totalSteps,
              "step-labels": stepLabels
            }, null, 8, ["current-step", "total-steps"]),
            (_unref(store).currentStep === 0)
              ? (_openBlock(), _createBlock(GetStartedStep, {
                  key: 0,
                  data: _unref(store).form,
                  isSaving: _unref(store).isSaving,
                  onUpdate: _unref(store).updateForm,
                  onNext: _unref(store).nextStep
                }, null, 8, ["data", "isSaving", "onUpdate", "onNext"]))
              : _createCommentVNode("", true),
            (_unref(store).currentStep === 1)
              ? (_openBlock(), _createBlock(CompanyDetailsStep, {
                  key: 1,
                  draftId: _unref(store).draftId,
                  industries: _unref(store).industries || [],
                  "company-industry-options": _unref(store).companyIndustryOptions,
                  onNext: _unref(store).nextStep,
                  onBack: _unref(store).prevStep
                }, null, 8, ["draftId", "industries", "company-industry-options", "onNext", "onBack"]))
              : _createCommentVNode("", true),
            (_unref(store).currentStep === 2)
              ? (_openBlock(), _createBlock(CompanyProfileStep, {
                  key: 2,
                  data: _unref(store).form,
                  industries: _unref(store).industries || [],
                  onUpdate: _unref(store).updateForm,
                  onNext: _unref(store).nextStep,
                  onBack: _unref(store).prevStep
                }, null, 8, ["data", "industries", "onUpdate", "onNext", "onBack"]))
              : _createCommentVNode("", true),
            (_unref(store).currentStep === 3)
              ? (_openBlock(), _createBlock(OperationsOverviewStep, {
                  key: 3,
                  data: _unref(store).form,
                  onUpdate: _unref(store).updateForm,
                  onNext: _unref(store).nextStep,
                  onBack: _unref(store).prevStep
                }, null, 8, ["data", "onUpdate", "onNext", "onBack"]))
              : _createCommentVNode("", true),
            (_unref(store).currentStep === 4)
              ? (_openBlock(), _createBlock(ManagerInformationStep, {
                  key: 4,
                  data: _unref(store).form,
                  isSaving: _unref(store).isSaving,
                  onUpdate: _unref(store).updateForm,
                  onSubmit: _unref(store).submit,
                  onNext: _unref(store).nextStep,
                  onBack: _unref(store).prevStep
                }, null, 8, ["data", "isSaving", "onUpdate", "onSubmit", "onNext", "onBack"]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
}
}

})